import React, { Component, createContext } from "react"
import PropTypes from "prop-types"
import { fetchTable, postToTable } from "../api/apiCalls"

let HistoryContext
const { Provider, Consumer } = (HistoryContext = createContext())

class HistoryProvider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      history: [],
      saveActivity: this.saveActivity,
      saveError: this.saveError,
      historyLoading: false,
      historyError: null,
      fetchHistory: this.fetchHistory,
    }
  }

  fetchHistory = (user) => {
    this.setState({ historyLoading: true, history: [] })
    fetchTable(user, "history")
      .then(async (response) => {
        if (response.ok) {
          let responseJSON = await response.json()
          this.setState({
            history: responseJSON,
            historyLoading: false,
          })
        } else {
          throw new Error("Unable to connect to activities feed.")
        }
      })
      .catch((error) => {
        this.setState({
          historyError: error.message,
          historyLoading: false,
        })
      })
  }

  saveActivity = async (
    user,
    file,
    uploaded = true,
    context = null,
    new_filename = null,
    message = null
  ) => {
    if (message) {
      message = message.split("fn_validate_import")[0]
      console.log(" MESSAGE ", message)
    }
    let activity = uploaded ? 1 : 2
    activity = context === "megafile" ? 7 : activity
    activity = context === "purchpost" ? 7 : activity
    await postToTable(user, "history", {
      user: user.name ? user.name : user.email,
      user_email: user.email,
      activity_type_id: activity,
      filename: file,
      context,
      new_filename,
      message,
    })
    return null
  }

  saveError = async (
    user,
    file,
    isReport,
    context = null,
    uploading = false,
    message = null
  ) => {
    let activity = isReport ? 9 : 10
    activity = uploading ? 11 : activity
    if (message) {
      message = message.split("fn_validate_import")[0]
      console.log(" MESSAGE ", message)
    }
    await postToTable(user, "history", {
      user: user.name ? user.name : user.email,
      user_email: user.email,
      activity_type_id: activity,
      filename: file,
      context,
      message,
    })
    return null
  }

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>
  }
}

HistoryProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { HistoryProvider, Consumer as HistoryConsumer, HistoryContext }
